
import { normalize_user_role } from '@/utils/system_constants/constant.js';
import { fetch_current_organization } from '@/services/organization_service.js';

function normalize_bool(value) {
  return value === true || value === 'true';
}

export default {
  name: 'UserLogin',
  components: {},
  data() {
    var data = {

    };

    return data;
  },

  mounted() {
    this.fetch_auth_token();
  },

  methods: {

    async fetch_auth_token() {
      var token = this.$route.params.token;
      var user_id = this.$route.params.user_id;
      var user_role = this.$route.params.user_role;
      var is_aic_one_login = this.$route.params.is_aic_one_login;
      var current_system = this.$route.params.current_system;
      var normalized_role = normalize_user_role(user_role);

      if (token && user_id && user_role) {
        await this.$store.dispatch('resetStore');
        sessionStorage.setItem('token', token);
        sessionStorage.setItem('user_id', user_id);
        sessionStorage.setItem('current_user_id', user_id);
        sessionStorage.setItem('otp_verified', true);
        sessionStorage.setItem('user_role', normalized_role);
        sessionStorage.setItem('current_role', normalized_role);
        sessionStorage.setItem('is_aic_one_login', is_aic_one_login);
        sessionStorage.setItem('current_platform', current_system);
        sessionStorage.setItem('first_time_login', 'false');

        this.$store.dispatch('setCurrentUserId', user_id);
        this.$store.dispatch('setCurrentRole', normalize_user_role(user_role));

        try {
          const organization_context = await fetch_current_organization();
          const organization = organization_context?.organization || null;
          this.$store.dispatch('setOrganization', organization);
          const is_organization_admin = normalize_bool(
            organization_context?.is_organization_admin
          );
          this.$store.dispatch(
            'setIsOrganizationAdmin',
            is_organization_admin
          );
          if (organization && is_organization_admin) {
            this.$router.replace({ name: 'OrganizationDashboard' });
            return;
          }
        } catch {
          this.$store.dispatch('setOrganization', null);
          this.$store.dispatch('setIsOrganizationAdmin', false);
        }

        if (is_admin_role(normalized_role)) {
          this.$router.replace({ name: 'GlobalOverview' });
          return;
        }

        if (user_role === "System Admin") {
          this.$router.replace({ name: 'GlobalOverview' });
          return;
        }
        this.$router.replace({ name: 'GlobalOverview' });
      }
      else {
        console.log("no user")
      }
    }
  }
}

function is_admin_role(role) {
  const normalized_role = String(role || '').trim().toLowerCase();
  return normalized_role.includes('admin') || normalized_role.includes('administrator');
}

